import { defineComponent as _defineComponent } from 'vue'
import type { Contributor, NewContributor } from '@ilteducation/content-ref-data-types';
import { computed, ref } from 'vue';
import ArrayInput from '@/components/base/ArrayInput.vue';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';
import { contributorFullName } from '@/foundations/helpers/contributorName';

type Props = {
  id?: string;
  title: string;
  item?: Contributor;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: Contributor;
}



const notEmpty = (val: any) => (val || '').length > 0 || 'This field is required';
const noWhitespace = (val: any) =>
  (val || '').length === (val || '').trim().length || 'No whitespace at beginning or end allowed';

const nameRules = [noWhitespace];
const requiredNameRules = [notEmpty, noWhitespace];

const model = ref<Partial<NewContributor>>({
  isOrganization: false,
});

// Organizations have a single name, kept in the `lastName` component. Blank
// components and the ids ArrayInput adds for drag tracking are stripped from
// the payload in the data provider.
const isOrganization = computed(() => !!model.value.isOrganization);

const heading = computed(() =>
  props.item ? `Edit contributor ${contributorFullName(props.item)}` : 'Add contributor',
);

return { __sfc: true,props, notEmpty, noWhitespace, nameRules, requiredNameRules, model, isOrganization, heading, ArrayInput, defaultRealms }
}

})